import React  from 'react'
import booleanHelper from '../../../Helpers/booleanHelper';
import mathHelper from '../../../Helpers/mathHelper';
import TargetRate from './TargetRate';


class PIPlannedAssignmentsMultiEditSubPanel extends React.Component 
{
    constructor(props) 
    {
        super(props);
        
        this.state = {
            pricingIds:this.getPricingIds(props.selectedCountries),
            shopCounts: this.getShopCounts(props.selectedCountries),
            applyValues: this.getApplyValues(props.selectedCountries),
            targetAssignmentRates:this.getRates(props.selectedCountries,[30,45,25,0]),
            targetCompletionRates:this.getRates(props.selectedCountries,[20,30,30,20]),
            defaultShopCounts:0,
            defaultAssignmentRate:[30,45,25,0],
            defaultCompletionRates:[20,30,30,20]
        };
        this.stateDidChanged()
    }

    componentDidMount() 
    {
        
    }

    componentDidUpdate(prevProps)
    {
        if(prevProps.selectedCountries!==this.props.selectedCountries)
        {
            this.setState({
                pricingIds:this.getPricingIds(this.props.selectedCountries),
                shopCounts: this.getShopCounts(this.props.selectedCountries),
                applyValues: this.getApplyValues(this.props.selectedCountries),
                targetAssignmentRates:this.getRates(this.props.selectedCountries,[30,45,25,0]),
                targetCompletionRates:this.getRates(this.props.selectedCountries,[20,30,30,20])
            });
        }
    }

    getShopCounts(selectedCountries)
    {
        let shopCountValues=new Array(selectedCountries.length);
        for (let i = 0; i < shopCountValues.length; i++) 
        {
            shopCountValues[i]= selectedCountries[i].numberOfPlannedAssignments>0
                                ? selectedCountries[i].numberOfPlannedAssignments
                                : selectedCountries[i].numberOfContractedAssignments;
            
        }
        return shopCountValues;
    }

    getPricingIds(selectedCountries)
    {
        let pricingIdValues=new Array(selectedCountries.length);
        for (let i = 0; i < pricingIdValues.length; i++) 
        {
            pricingIdValues[i]= selectedCountries[i].pricingId;
        }
        return pricingIdValues;
    }
    
    getApplyValues(countries)
    {
        return new Array(countries.length).fill(false);
    }

    getRates(countries,base)
    {
        let rates=new Array(countries.length);
        for (let index = 0; index < countries.length; index++) 
        {
            rates[index]=[...base]    
        }
        return rates;
    }

    stateDidChanged()
    {
        var subpanelValue={
            pricingIds: this.state.pricingIds,
            shopCounts:this.state.shopCounts,
            applyValues:this.state.applyValues,
            targetAssignmentRates:this.state.targetAssignmentRates,
            targetCompletionRates:this.state.targetCompletionRates
        };
        this.props.onChange(subpanelValue);
    }


    renderApplyTargetRateCheckboxHeaderCell()
    {
        return(
            <div 
                className="col-2 p-1 pointer"
                onClick={()=>{
                    let temp=this.state.applyValues;
                    temp.fill(!booleanHelper.isAllTrue(temp));
                    this.setState({applyValues:temp},
                        this.stateDidChanged());
                }}
            >
                Apply Target Rate ({booleanHelper.isAllTrue(this.state.applyValues)?"Deselect":"Select"} all)
            </div>
        );
    }

    renderHeader()
    {
        return(
            <div className="row text-center m-1 d-flex align-items-center justify-content-center bold">
                <div className="col-1 p-1">Country</div>
                <div className="col-2 p-1">Planned Shop Count</div>
                {this.renderApplyTargetRateCheckboxHeaderCell()}
                <div className="col p-1">Target Assignment Rate (%)</div>                
                <div className="col p-1">Target Completion Rate (%)</div>                
            </div>
        );
    }


    renderCountryRow(countryWithNumbers, index)
    {
        return(
            <div className="row text-center m-1 d-flex align-items-center justify-content-center strippedrow rounded w-100" key={"countryrow"+index}>
                <div className="col-1 p-1" key="countrydiv">
                    {countryWithNumbers.country +" ("+countryWithNumbers.pricingId+")"}
                </div>
                <div className="col-2 p-1" key="plannedAssignmentsdiv">
                    <input
                        className="form-control form-control-sm text-center"
                        type="number"
                        min={0}
                        value={mathHelper.RemoveLeadingZeros( this.state.shopCounts[index])}
                        onChange={(e)=>{
                            let tempShopCounts=this.state.shopCounts;
                            tempShopCounts[index]=isNaN(parseInt(e.target.value))?0:parseInt(e.target.value);
                            this.setState({shopCounts:tempShopCounts},
                                this.stateDidChanged());
                        }}
                    />
                </div>
                <div className="col-2 p-1" key="targetAssignmentRatediv">
                    <input 
                        type="checkbox"
                        checked={this.state.applyValues[index]}
                        onChange={(e)=>{
                            let tempApplyValues=this.state.applyValues;
                            tempApplyValues[index]=e.target.checked;
                            this.setState({applyValues: tempApplyValues}
                                ,this.stateDidChanged());
                        }}
                    />
                </div>
                <div className="col p-1" key="targetCompletionRatediv">
                    <TargetRate
                        rates={this.state.targetAssignmentRates[index]}
                        disabled={!this.state.applyValues[index]}
                        onChange={(value)=>{
                                let tempRates=this.state.targetAssignmentRates;
                                tempRates[index]=value;
                                this.setState({targetAssignmentRates:tempRates}
                                    ,this.stateDidChanged());
                            }}
                    />
                </div>
                <div className="col p-1">
                    <TargetRate
                        rates={this.state.targetCompletionRates[index]}
                        disabled={!this.state.applyValues[index]}
                        onChange={(value)=>{
                            let tempRates=this.state.targetCompletionRates;
                            tempRates[index]=value;
                            this.setState({targetCompletionRates:tempRates}
                                ,this.stateDidChanged());
                        }}
                    />
                </div>                                
            </div>
        );
    }

    
    renderDefaultValuesRow()
    {
        return(
            <div className="row text-center m-1 d-flex align-items-center justify-content-center rounded bg-default" key="defaultValuesRow">
                <div className="col-1 p-1" key="countrydiv"></div>
                <div className="col-2 p-1" key="plannedAssignmentsdiv">
                    <div className="bold">Default Planned Shop Count</div>
                    <div className="d-flex">
                        <input
                            className="form-control form-control-xs text-center w-50"
                            type="number"
                            min={0}
                            value={mathHelper.RemoveLeadingZeros(this.state.defaultShopCounts)}
                            onChange={(e)=>{
                                let numval=parseInt(e.target.value,10);
                                numval=isNaN(numval) ? 0 : numval;
                                this.setState({defaultShopCounts:numval});
                            }}
                        />
                        <input 
                            type="button"
                            className="form-control form-control-xs w-50"
                            value="Apply for all"
                            disabled={this.state.defaultShopCounts<1}
                            onClick={()=>{
                                let temp=this.state.shopCounts.fill(this.state.defaultShopCounts);
                                this.setState({shopCounts:temp}, this.stateDidChanged());
                            }}
                        /> 
                        
                        
                    </div>
                </div>
                <div className="col-2 p-1" key="targetAssignmentRatediv">
                    
                </div>
                <div className="col p-1" key="targetCompletionRatediv">
                    <div className="bold">Default Target Assignment Rate (%)</div>
                    <div className="d-flex">
                        <TargetRate
                            rates={this.state.defaultAssignmentRate}
                            className="form-control form-control-xs"
                            onChange={(value)=>{
                                    this.setState({defaultAssignmentRate:value});
                                }}
                        />
                        <input 
                            className="form-control form-control-xs w-25"
                            type="button"
                            value="Apply for all"
                            disabled={mathHelper.Sum(this.state.defaultAssignmentRate)!==100}
                            onClick={()=>{
                                let temp=this.state.targetAssignmentRates;
                                for(let i=0; i<temp.length;i++)
                                {
                                    temp[i]=[...this.state.defaultAssignmentRate];
                                }
                                this.setState({targetAssignmentRates:temp}, this.stateDidChanged());
                            }}
                        />
                    </div>
                </div>
                <div className="col p-1">
                    <div className="bold">Default Target Completion Rate (%)</div>
                    <div className="d-flex">
                        <TargetRate
                            rates={this.state.defaultCompletionRates}
                            className="form-control form-control-xs"
                            onChange={(value)=>{
                                this.setState({defaultCompletionRates:value});
                            }}
                        />
                        <input 
                            className="form-control form-control-xs w-25"
                            type="button"
                            value="Apply for all"
                            disabled={mathHelper.Sum(this.state.defaultCompletionRates)!==100}
                            onClick={()=>{
                                let temp=this.state.targetCompletionRates;
                                for(let i=0; i<temp.length;i++)
                                {
                                    temp[i]=[...this.state.defaultCompletionRates];
                                }
                                this.setState({targetCompletionRates:temp}, this.stateDidChanged());
                            }}
                        />
                    </div>
                </div>                                
            </div>
        );
    }

    
    render()
    {
        let rows=[];
        this.props.selectedCountries.forEach((countryWithNumbers,index) => {
            rows.push(this.renderCountryRow(countryWithNumbers, index))
        });
        return (
            <div className="container border strippedback rounded m-1">
                {this.renderDefaultValuesRow()}
                {this.renderHeader()}
                {rows}
            </div>
        );
    } 
}


export default PIPlannedAssignmentsMultiEditSubPanel;
